export const shortDescription = (text: string | undefined | null, limit: number) => {
  if (!text) {
    return null;
  }
  text = text.trim();
  if (text.length <= limit) return text;
  text = text.slice(0, limit);
  return text + '...';
};
